import { render, staticRenderFns } from "./AddrDeleteModal.vue?vue&type=template&id=65ae785a&"
import script from "./AddrDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AddrDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports